import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) :
    null, // 用户基础信息 请使用 getters.user 获取,
    login_show: false,
    isLogin: localStorage.getItem('token') ? true : false,
    vip_show: false,
    isvip: localStorage.getItem('userInfo') != null && JSON.parse(localStorage.getItem('userInfo')).bind_card > 0 ?
      '已开通VIP' : '开通VIP',
    count: 1
  },
  mutations: {
    SET_USER(state, user) {
      state.userInfo = user
    },
    add(state, value) {
      state.userInfo = value
    },
    setUserInfo(state, value) {
      console.log(value)
      state.userInfo = value
    },
    login(state, value) {
      console.log(value)
      state.login_show = value
    },
    login_over(state, value) {
      state.login_show = false
      state.isLogin = true
    },
    openVip(state, value) {
      state.vip_show = value
    },
    // 退出登录
    logout(state, value) {
      state._userInfo = null
      state.user_token = null
      state.isLogin = false
      // localStorage.removeItem('userInfo')
      // localStorage.removeItem('user_token')
      localStorage.clear()
    }
  },
  actions: {
    // setSearchKey(context, value) {
    // 	context.commit('changeSearchKey', value)
    // }
  },
  getters: {
    // 用户token
    userToken(state) {
      console.log(111111111111)
      // if (state._userInfo && state._userInfo.token) {
      // 	return state._userInfo.token
      // } else {
      // 	return null
      // }
    },
    // 用户id
    userId(state) {
      // if (state._userInfo && state._userInfo.id) {
      // 	return state._userInfo.id
      // } else {
      // 	return null
      // }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js